import { DELIVERY_TYPE, PICKUP_TYPE } from '../webStorage/keys/sessionKeys';
import { getCountryCode } from './getCountryCode';

export const isRestaurantOrderTypeChangeDisabled = (restaurantSetting) =>
  Number(restaurantSetting?.settings?.global?.restaurant_order_type_change_diable) === 1;

export const getEligibleOrderTypes = () => {
  return 7;
};

export const getDefaultOrderType = () => {
  const countryCode = getCountryCode();
  if ((countryCode == 'id' || countryCode == 'th')) {
    // default is set for pickup in indonesia and thailand
    return PICKUP_TYPE;
  }
  const eligibleOrderType = getEligibleOrderTypes();
  if ((eligibleOrderType & 2) === 2) {
    return DELIVERY_TYPE;
  }
};
